import LandingContainer from "./LandingContainer";

export default LandingContainer;
